import { env } from '@/utils/shared/env';
import { Paths } from '@/router/constants';

/**
 * Logs out the user and redirects to the login page.
 * This clears the authentication state and performs a full page redirect.
 */
export function performSignOut(): void {
    const realm = localStorage.getItem('realm');
    if (realm) {
        const tokenKey = `${realm}user:${env.VITE_KEYCLOAK_URL}/auth:hub`;
        localStorage.removeItem(tokenKey);
    }

    if (env.VITE_MODE === 'local') {
        window.location.href = Paths.LOCAL_LOGIN;
    } else {
        window.location.replace(`${env.VITE_HUB_URL}/login`);
    }
}
